export const pageReady = (): void => {
	// no-op for now, to be properly cleaned up when FFs are removed - KITKAT-1419
};
